module.exports = __webpack_public_path__ + "static/img/44.c33060bb.png";